export const financeNumberFormat = (amount, max = 2, min = 2) => new Intl.NumberFormat("en-US", {
  maximumFractionDigits: max,
  minimumFractionDigits: min,
}).format(amount);
